/* tslint:disable */
/* eslint-disable */
/**
 * Stotles Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TeamDto } from './TeamDto';
import {
    TeamDtoFromJSON,
    TeamDtoFromJSONTyped,
    TeamDtoToJSON,
} from './TeamDto';

/**
 * 
 * @export
 * @interface SearchTeamsResponse
 */
export interface SearchTeamsResponse {
    /**
     * 
     * @type {Array<TeamDto>}
     * @memberof SearchTeamsResponse
     */
    teams: Array<TeamDto>;
}

/**
 * Check if a given object implements the SearchTeamsResponse interface.
 */
export function instanceOfSearchTeamsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "teams" in value;

    return isInstance;
}

export function SearchTeamsResponseFromJSON(json: any): SearchTeamsResponse {
    return SearchTeamsResponseFromJSONTyped(json, false);
}

export function SearchTeamsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchTeamsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'teams': ((json['teams'] as Array<any>).map(TeamDtoFromJSON)),
    };
}

export function SearchTeamsResponseToJSON(value?: SearchTeamsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'teams': ((value.teams as Array<any>).map(TeamDtoToJSON)),
    };
}

